import { EvidenceDimension } from '../contract/constants.js';
import { immutable } from '../contract/stable.js';

export function createEvidenceItem(input) {
  const required = ['evidenceId','eventId','dimension','sourceId','lineageId','provenanceComplete','supportsCandidate','contradictsCandidate','recallDerived','reflexOriginated','timestamp'];
  const missing = required.filter((key) => input[key] === undefined || input[key] === null);
  if (missing.length) throw new Error(`EVIDENCE_INVALID: missing ${missing.join(',')}`);
  for (const key of ['evidenceId','eventId','sourceId','lineageId','timestamp']) {
    if (typeof input[key] !== 'string' || !input[key].trim()) throw new Error(`EVIDENCE_INVALID: ${key} must be non-empty`);
  }
  for (const key of ['provenanceComplete','supportsCandidate','contradictsCandidate','recallDerived','reflexOriginated']) {
    if (typeof input[key] !== 'boolean') throw new Error(`EVIDENCE_INVALID: ${key} must be boolean`);
  }
  if (!Object.values(EvidenceDimension).includes(input.dimension)) throw new Error('EVIDENCE_INVALID: unknown dimension');
  return immutable({ ...input });
}
